import React, {useMemo} from 'react';
import {useRecoilValue} from 'recoil';

import styles from '../styles.module.scss';
import {AddressList} from '../../../store';

interface Props {
  info: BrandListItemType | undefined;
  openSeparators: () => void;
}

export default function DetailInformation({info, openSeparators}: Props) {
  const addressList = useRecoilValue(AddressList);

  const findAddressObj = (id: number, list: Address[]): Address => {
    let addressInfo: Address = {
      id: -1,
      address: '',
      child: [],
    };
    list.forEach(address => {
      if (id === address.id) {
        addressInfo = address;
      }
    });
    return addressInfo;
  };

  const shortAddress = useMemo(() => {
    let address1Item;
    let address2Item;
    if (addressList.length > 0 && info?.address1) {
      address1Item = findAddressObj(info?.address1, addressList);
      address2Item = findAddressObj(info?.address2, address1Item?.child || []);
      return `${address1Item.address} ${address2Item.address}`;
    }
    return '';
  }, [addressList, info]);

  return (
    <div>
      <div className={styles.detailInformation}>
        <div className={styles.infoWrapper}>
          <div className={styles.info}>
            <div
              className={styles.logo}
              style={{
                background: `url(${info?.thumbnail}) no-repeat center / cover`,
              }}></div>
            <div className={styles.txtWrapper}>
              <div className={`${styles.title}`}>{info?.title}</div>
              <div className={`${styles.areaWrapper} `}>
                <div className={styles.area}>{shortAddress}</div>
                <div
                  className={styles.divider}
                  style={{
                    display:
                      info?.childPlaces && info?.childPlaces.length > 1
                        ? 'flex'
                        : 'none',
                  }}></div>
                <div
                  className={styles.areaSelector}
                  onClick={() => openSeparators()}
                  style={{
                    display:
                      info?.childPlaces && info?.childPlaces.length > 1
                        ? 'flex'
                        : 'none',
                    cursor: 'pointer',
                  }}>
                  <span className={styles.selectedArea}>
                    {info?.separator || ''}
                  </span>
                  <span className={styles.areaDropDown}>
                    <span className={styles.dropdownIcon}></span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.descriptions}>{info?.subtitle}</div>
        {info?.hashtags && info.hashtags.length > 0 && (
          <div className={styles.tagsWrapper}>
            {info.hashtags.map((item, index) => (
              <div key={index} className={styles.tag}>{`#${item}`}</div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
